module.exports = __webpack_public_path__ + "static/img/wisdom111.f4bd02d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/wisdom111.png
// module id = rfV7
// module chunks = 1